'use client';

import { ReactNode, createContext, useContext, useMemo } from 'react';
import type { CustomerNotification } from '@/entities/customer-notification/api/customer-notifications/types';

type ItemContextValue = {
    notification: CustomerNotification;
    isUnread: boolean;
};

export const CustomerNotificationItemContext = createContext<ItemContextValue | null>(null);

export const CustomerNotificationItemProvider = ({
    notification,
    isUnread,
    children,
}: {
    notification: CustomerNotification;
    isUnread: boolean;
    children?: ReactNode;
}) => {
    const value = useMemo(() => ({ notification, isUnread }), [notification, isUnread]);

    return (
        <CustomerNotificationItemContext.Provider value={value}>
            {children}
        </CustomerNotificationItemContext.Provider>
    );
};

export const useCustomerNotificationItem = () => {
    const value = useContext(CustomerNotificationItemContext);
    if (!value) {
        throw new Error('useCustomerNotificationItem requires CustomerNotificationItemProvider');
    }
    return value;
};
